let deconnecterUtilisateur;

export default {
    enregistrerMethodeDeconnexion: (methode) => {
        deconnecterUtilisateur = methode;
    },

    get: async (path, params) => {
        let url = `${path}`;
        if (params) {
            if (typeof params === 'object') {
                let i = 0;
                for (let [clef, valeur] of Object.entries(params)) {
                    url += (i === 0) ? '?' : '&';
                    url += encodeURIComponent(clef) + '=' + encodeURIComponent(valeur.toString());
                    i++;
                }
            } else {
                url += params;
            }
        }
        return fetch(url, {
            headers: {
                Authorization: localStorage.getItem('jeton'),
                'Base-Selectionnee': window.baseSelectionnee
            },
            credentials: 'include'
        })
        .then(async reponse => {
            if (reponse.status >= 400) {
                if (reponse.status === 401 || reponse.status === 403) {
                    if (deconnecterUtilisateur) {
                        deconnecterUtilisateur();
                    }
                }
                return reponse.json().then(donnees => { return { codeHttp: reponse.status, ...donnees }; });
            } else {
                return reponse.json();
            }
        });
    },

    post: async (path, body, baseSelectionnee) => {
        return fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: localStorage.getItem('jeton'),
                'Base-Selectionnee': baseSelectionnee ?? window.baseSelectionnee
            },
            credentials: 'include',
            mode: 'cors',
            body: JSON.stringify(body)
        })
        .then(async reponse => {
            if (reponse.status >= 400) {
                return reponse.json().then(donnees => { return { codeHttp: reponse.status, ...donnees }; });
            } else {
                return reponse.json();
            }
        });
    }
};